import axios from "axios";

export function getReviewStates() {
    const metaData = {
        withCredentials: true,
    };

    return new Promise((resolve) => {
        axios
        .get(`${process.env.REACT_APP_BACKEND}/reviews/state`, metaData)
        .then((response) => {
            resolve(response.data)
        })
        .catch((e) => {
            resolve(e);
        });
    });
}